var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.55599 16.8567C0.55599 17.2249 0.854466 17.5234 1.22266 17.5234L7.22266 17.5234C7.59085 17.5234 7.88932 17.2249 7.88932 16.8567C7.88932 16.4885 7.59085 16.19 7.22266 16.19L1.88932 16.19L1.88932 10.8567C1.88932 10.4885 1.59085 10.19 1.22266 10.19C0.854466 10.19 0.555989 10.4885 0.555989 10.8567L0.55599 16.8567ZM17.6028 1.14321C17.6028 0.775015 17.3043 0.476538 16.9361 0.476539L10.9361 0.476539C10.568 0.476539 10.2695 0.775015 10.2695 1.1432C10.2695 1.5114 10.568 1.80987 10.9361 1.80987L16.2695 1.80987L16.2695 7.1432C16.2695 7.5114 16.5679 7.80987 16.9361 7.80987C17.3043 7.80987 17.6028 7.51139 17.6028 7.14321L17.6028 1.14321ZM1.69406 17.3281L17.4075 1.61461L16.4647 0.6718L0.751252 16.3853L1.69406 17.3281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.96a228aa421eed307e93567d50346196.svg";
export { ForwardRef as ReactComponent };